'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { usePlpContext } from 'plp/context'
import { useRestorePosition } from 'plp/hooks/useRestorePosition'
import type { UseRestorePosition } from 'plp/hooks/useRestorePosition/useRestorePosition'
import { useVirtualPages } from 'plp/hooks/useVirtualPages'
import { type ReactNode, useRef } from 'react'
import { applyStylesIf, cx } from 'utils/cx'
import { useMatchMedia } from 'utils/matchMedia/hooks'

import styles from './Pagination.module.scss'
import mq from 'utils/matchMedia/styles/MatchMediaQueries.module.scss'

export function Pagination({
	children,
	total,
	perPage,
}: {
	children?: (
		count: number,
		showAsSmall: boolean,
		pendingScrollSlot: UseRestorePosition
	) => ReactNode
	total: number
	perPage: number
}) {
	const [isSmall] = useMatchMedia([mq.issmall])
	const { catalogId } = usePlpContext()
	const nextRef = useRef<HTMLDivElement>(null)
	const { isMobile } = useMasterData()
	const { count } = useVirtualPages(catalogId, total, nextRef, perPage)
	const showAsSmall = (!isMobile && isSmall) || isMobile
	const moreResults = count < total
	const pendingScrollSlot = useRestorePosition(catalogId)
	return (
		<>
			{children?.(count, showAsSmall, pendingScrollSlot)}
			<div
				role='presentation'
				className={cx(
					styles.moreResults,
					applyStylesIf(!moreResults, styles.noMore)
				)}
				ref={nextRef}
			/>
		</>
	)
}
